import request from "@/utils/request";

/**
 * 后台「随堂测试记录统计」接口（2026-10-06 新增）。
 *
 * ⚠️ 全部走 /sys/ 前缀（后台管理端约定，前端 request.js 按此区分后台/小程序侧）。
 * ⚠️ 三个读端点（summary / pageList / testDetail）与写端点（export）**在服务端各自独立
 * enforce 了一次数据权限**，前端不要再自己过滤 —— 前端过滤只是界面表现，
 * 真正拦住越权的是服务端。
 */

/**
 * 统计卡：提报场次 / 覆盖教练 / 覆盖学员 / 录报完整率
 * @param param { scope, areaIdList, coachName, classTimeStart, classTimeEnd, classType, campusName }
 */
export const selectClassScoreSummary = (param) => {
    return request({
        url: '/sys/classScoreStat/summary',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(param),
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};

/**
 * 场次分页列表
 */
export const selectClassScorePage = (param) => {
    return request({
        url: '/sys/classScoreStat/pageList',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(param),
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};

/**
 * 某场次的逐学员成绩明细（详情弹窗）
 * @param testId 场次ID
 * @param param  与列表同口径的筛选条件（服务端用它做可见性判定）
 */
export const selectClassScoreDetail = (testId, param) => {
    return request({
        url: '/sys/classScoreStat/testDetail',
        method: 'POST',
        dataType: "json",
        // testId 走 query（配合 @RequestParam），筛选条件走 body
        params: { testId },
        data: JSON.stringify(param || {}),
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};

/**
 * 导出（异步：接口立即返回，文件稍后从右上角下载中心取）
 */
export const exportClassScoreStat = (param) => {
    return request({
        url: '/sys/classScoreStat/export',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(param),
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};

/**
 * 作废一个场次（逻辑删除 is_delete=1）。2026-10-20 新增。
 *
 * 为什么需要：小程序提报接口没有幂等，网络重试 / 重复提交会在同一分钟造出多个场次，
 * 而 is_delete 从来没人置过 1 —— 垃圾场次永久污染「提报场次 / 完整率」。
 * 作废后该场次立刻从统计里消失（统计 SQL 本来就带 is_delete = 0）。
 *
 * ⚠️ param 要传与列表同口径的筛选条件：服务端用它做校区可见性校验，
 *    不是「传个 testId 就能作废全站」。
 */
export const voidClassScoreTest = (testId, param) => {
    return request({
        url: '/sys/classScoreStat/voidTest',
        method: 'POST',
        dataType: "json",
        params: { testId },
        data: JSON.stringify(param || {}),
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};

/**
 * 恢复一个已作废场次（is_delete 置回 0）。2026-10-20 新增，配合作废形成闭环。
 *
 * 作废之后那条记录在所有列表/统计/详情里都会消失（都带 is_delete = 0），
 * 没有恢复入口的话「作废」就是不可逆的盲操作 —— 误点一次，那场课的提报数据
 * 就永久从报表里蒸发。
 *
 * 用法：先在列表勾「显示已作废」，已作废行会置灰并出现「恢复」按钮。
 * ⚠️ param 同作废，必须带列表筛选条件（服务端据此校验校区归属）。
 */
export const restoreClassScoreTest = (testId, param) => {
    return request({
        url: '/sys/classScoreStat/restoreTest',
        method: 'POST',
        dataType: "json",
        params: { testId },
        data: JSON.stringify(param || {}),
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};
